export class PageListEmpty {
    perPage: 1;
    pages: 1;
    page: 1;
    total: 0;
    list: [];
}